import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGerenciadorPrecosDatapoint } from '../../@types';
import { RootState } from '../../@types/RootState';

export type RowData = Partial<IGerenciadorPrecosDatapoint>;

export type GetFamilyClusterModalDatapointsState = RowData[];

const initialState: GetFamilyClusterModalDatapointsState = [];

const slice = createSlice({
  name: 'getFamilyClusterModal/datapoints',
  initialState,
  reducers: {
    SET_GET_FAMILY_CLUSTER_MODAL_DATAPOINTS: (_state, { payload }: PayloadAction<GetFamilyClusterModalDatapointsState>) => payload,
    UPDATE_GET_FAMILY_CLUSTER_MODAL_DATAPOINT: (
      state,
      {
        payload,
      }: {
        payload: {
          index: number;
          updatedData: Partial<RowData>;
        };
      },
    ) => {
      state[payload.index] = { ...state[payload.index], ...payload.updatedData };
    },
    RESET_GET_FAMILY_CLUSTER_MODAL_DATAPOINTS() {
      return [];
    },
  },
});

export const { SET_GET_FAMILY_CLUSTER_MODAL_DATAPOINTS, UPDATE_GET_FAMILY_CLUSTER_MODAL_DATAPOINT, RESET_GET_FAMILY_CLUSTER_MODAL_DATAPOINTS } = slice.actions;

export const selectorGetFamilyClusterModalDatapoints = (state: RootState) => state.getFamilyClusterModalReducer.datapoints;

export default slice.reducer;
